import React, { Component} from 'react';
import './People.css';
import { IconContext } from "react-icons";
import { BiChevronLeft, BiSidebar } from "react-icons/bi";


class People extends Component {
  constructor(props) {
    super(props);

    this.state = {
      
    };
  }

  componentDidUpdate(){
    
  }
 
  componentDidMount(){
  }

  render() {
    return (
      <div className = "peoplePage peoplescrollableSec">
        <div className = "peopleSection">
          <div className = "peopleLabel">
            <h3>Principal Investigator</h3>
          </div>
          <div className = "peopleIcon3 fadePeopleAnimation">
            
            <div className = "peoplePic" style = {{"backgroundImage" : "url('pics/robert.jpg')"}}>

            </div>
            <div className = "peopleBio">
              <p class="name">Robert Xiao</p>
              <p class="title">Assistant Professor</p>
              <p class="links">
                <a href="https://robertxiao.ca" target="_blank">Website</a> | 
                <a href="https://x.com/nneonneo" target="_blank"> Twitter</a>
              </p>

            </div>
          </div>
        </div>
        <div className = "peopleSection">
          <div className = "peopleLabel">
            <h3>Students in the Lab</h3>
          </div>
            <div className = "peopleIcon fadePeopleAnimation">
              
              <div className = "peoplePic" style = {{"backgroundImage" : "url('pics/michael.jpg')"}}>
                
              </div>
              <div className = "peopleBio">
                <p class="name">Michael Yin</p>
                <p class="title">PhD Student</p>
                <p class="links">
                  <a href="https://www.mikeyin.xyz/" target="_blank">Website</a> | 
                  <a href="https://x.com/yinsecurity1" target="_blank"> Twitter</a>
                </p>

              </div>
            </div>
            <div className = "peopleIcon fadePeopleAnimation">
            
              <div className = "peoplePic"  style = {{"backgroundImage" : "url('pics/xincheng.jpeg')"}}>
                
              </div>
              <div className = "peopleBio">
                <p class="name">Xincheng Huang</p>
                <p class="title">PhD Student</p>
                <p class="links">
                  <a href="https://xincheng.me/" target="_blank">Website</a> | 
                  <a href="https://x.com/Xincheng_Huang" target="_blank"> Twitter</a>
                </p>

              </div>
            </div>
            <div className = "peopleIcon fadePeopleAnimation">
            
              <div className = "peoplePic"  style = {{"backgroundImage" : "url('pics/bu.jpeg')"}}>
                
              </div>
              <div className = "peopleBio">
                <p class="name">Bu Li</p>
                <p class="title">PhD Student</p>
                <p class="links">
                  <a href="https://www.linkedin.com/in/bu-li-8b3995185/" target="_blank">Linkedin</a>
                </p>

              </div>
            </div>
            <div className = "peopleIcon fadePeopleAnimation">
            
              <div className = "peoplePic"  style = {{"backgroundImage" : "url('pics/kaseya.jpeg')"}}>
                
              </div>
              <div className = "peopleBio">
                <p class="name">Kaseya Xia</p>
                <p class="title">PhD Student</p>
                <p class="links">
                  <a href="https://www.linkedin.com/in/kaseya-xia/" target="_blank">Linkedin</a>
                </p>

              </div>
            </div>
            <div className = "peopleIcon fadePeopleAnimation">
              <div className = "peoplePic" style = {{"backgroundImage" : "url('pics/peyman.jpg')"}}>  
              </div>
              <div className = "peopleBio">
                <p class="name">Peyman Gholami</p>
                <p class="title">PhD Student</p>
                <p class="links">
                  <a href="https://www.cs.ubc.ca/~peymang/" target="_blank">Website</a> | 
                  <a href="https://www.linkedin.com/in/pgholami/" target="_blank"> Linkedin</a>
                </p>
              </div>
            </div>
            <div className = "peopleIcon fadePeopleAnimation">
              <div className = "peoplePic" style = {{"backgroundImage" : "url('pics/books.jpg')"}}>  
              </div>
              <div className = "peopleBio">
                <p class="name">Ritik Vatsal</p>
                <p class="title">Master's Student</p>
                <p class="links">
                  {/* <a href="https://www.linkedin.com/in/neilxufan/" target="_blank"> Linkedin</a> */}
                </p>
              </div>
            </div>
            <div className = "peopleIcon fadePeopleAnimation">
              <div className = "peoplePic" style = {{"backgroundImage" : "url('pics/books.jpg')"}}>  
              </div>
              <div className = "peopleBio">
                <p class="name">Peyton Rapo</p>
                <p class="title">Master's Student</p>
                <p class="links">
                  {/* <a href="https://www.linkedin.com/in/neilxufan/" target="_blank"> Linkedin</a> */}
                </p>
              </div>
            </div>
            <div className = "peopleIcon fadePeopleAnimation">
              <div className = "peoplePic" style = {{"backgroundImage" : "url('pics/angela.png')"}}>  
              </div>
              <div className = "peopleBio">
                <p class="name">Angela Chiang</p>
                <p class="title">Undergrad Student</p>
                <p class="links">
                  <a href="https://www.linkedin.com/in/angela-chiang-a12a02231/" target="_blank"> Linkedin</a>
                </p>
              </div>
            </div>
            <div className = "peopleIcon fadePeopleAnimation">
              <div className = "peoplePic" style = {{"backgroundImage" : "url('pics/books.jpg')"}}>  
              </div>
              <div className = "peopleBio">
                <p class="name">Dieter Frehlich</p>
                <p class="title">Undergrad Student</p>
                <p class="links">
                  {/* <a href="https://www.linkedin.com/in/angela-chiang-a12a02231/" target="_blank"> Linkedin</a> */}
                </p>
              </div>
            </div>
            <div className = "peopleIcon fadePeopleAnimation">
              <div className = "peoplePic" style = {{"backgroundImage" : "url('pics/books.jpg')"}}>  
              </div>
              <div className = "peopleBio">
                <p class="name">Kelvin Ding</p>
                <p class="title">Undergrad Student</p>
                <p class="links">
                  {/* <a href="https://www.linkedin.com/in/angela-chiang-a12a02231/" target="_blank"> Linkedin</a> */}
                </p>
              </div>
            </div>
            <div className = "peopleIcon fadePeopleAnimation">
              <div className = "peoplePic" style = {{"backgroundImage" : "url('pics/books.jpg')"}}>  
              </div>
              <div className = "peopleBio">
                <p class="name">Katherine Lim</p>
                <p class="title">Undergrad Student</p>
                <p class="links">
                  {/* <a href="https://www.linkedin.com/in/angela-chiang-a12a02231/" target="_blank"> Linkedin</a> */}
                </p>
              </div>
            </div>
            

        </div>
        <div className = "peopleSection">
          <div className = "peopleLabel">
            <h3>Alumni</h3>
          </div>
          <div className = "peopleIcon2 fadePeopleAnimation">
            <div className = "peoplePic" style = {{"backgroundImage" : "url('pics/books.jpg')"}}>  
            </div>
            <div className = "peopleBio">
              <p class="name">Neil Fan</p>
              <p class="title">Master's Student</p>
              <p class="links">
                <a href="https://www.linkedin.com/in/neilxufan/" target="_blank"> Linkedin</a>
              </p>
            </div>
          </div>
          <div className = "peopleIcon2 fadePeopleAnimation">
            <div className = "peoplePic" style = {{"backgroundImage" : "url('pics/books.jpg')"}}>  
            </div>
            <div className = "peopleBio">
              <p class="name">Ege Unlu</p>
              <p class="title">Master's Student</p>
              <p class="links">
                <a href="https://www.linkedin.com/in/ardaegeunlu/" target="_blank"> Linkedin</a>
              </p>
            </div>
          </div>
          <div className = "peopleIcon2 fadePeopleAnimation">
            <div className = "peoplePic" style = {{"backgroundImage" : "url('pics/books.jpg')"}}>  
            </div>
            <div className = "peopleBio">
              <p class="name">Tim Straubinger</p>
              <p class="title">Master's Student</p>
              <p class="links">
                <a href="https://www.linkedin.com/in/tim-straubinger-166a49211/" target="_blank"> Linkedin</a>
              </p>
            </div>
          </div>
          <div className = "peopleIcon2 fadePeopleAnimation">
            <div className = "peoplePic" style = {{"backgroundImage" : "url('pics/books.jpg')"}}>  
            </div>
            <div className = "peopleBio">
              <p class="name">James Riddell</p>
              <p class="title">Undergrad Student</p>
              <p class="links">
                <a href="https://www.linkedin.com/in/james-riddell1/" target="_blank"> Linkedin</a>
              </p>
            </div>
          </div>
        </div>
        
        <div className = "peopleFooter"></div>
      </div>
    )
  }
}

export default People;
